import { render } from "./RebootDevice.vue?vue&type=template&id=470cce28"
import script from "./RebootDevice.vue?vue&type=script&lang=js"
export * from "./RebootDevice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__